import React, {useState, useEffect} from 'react';
import classNames from 'classnames';
import {createWorkspace, finalizeWorkspace, generateWorkspace} from "../../utils/api.utils";

import bugsnag from '@bugsnag/js';
import bugsnagReact from '@bugsnag/plugin-react';
import {doTrack} from "../../utils/utils";
import {PreflightCheck} from "../../signup/PreflightCheck";
import {ConnectToSlack} from "../../signup/ConnectToSlack";
import {ConnectToZoom} from "../../signup/ConnectToZoom";
import {OfficeConfiguration} from "../../signup/OfficeConfiguration";
import {FinalStep} from "../../signup/FinalStep";
import {Email} from "../../signup/Email";
import _ from 'lodash';

class _CardForm extends React.Component {
    constructor(props) {
        super(props);
        this.stripe = props.stripe;
        this.doStripe = this.doStripe.bind(this);
    }


    doStripe() {
        this.props.onError(null);
        return this.stripe.createToken({name: "Name"}).then((res) =>
            finalizeWorkspace({
                stripeToken: res.token,
                email: this.props.email,
                subdomain: this.props.subdomain,
                size: this.props.size,
                workspaceToken: this.props.workspaceToken
            }).then(() => {
                generateWorkspace({
                    email: this.props.email,
                    token: this.props.workspaceToken
                }).then(() => this.props.onCompletion())
                    .catch(error => {
                        if (error.data) {
                            this.props.onError(error.data.errors);
                        } else {
                            this.props.onError(error.errors);
                        }
                    });
            }).catch(error => {
                if (error.data) {
                    this.props.onError(error.data.errors);
                } else {
                    this.props.onError(error.errors);
                }
            })
        ).catch(error => {
            if (error.data) {
                this.props.onError(error.data.errors);
            } else {
                this.props.onError(error.errors);
            }
        });
    };

    render() {
        return <div className={"flexRowContainer"}>
            <h4 className={"mb7"}>Payment Information</h4>
            <p>Don't worry, we won't charge you yet! The first month is on us.</p>
            <div className={"mb20"}>
                <CardElement/>
            </div>
            <div className={"flexColumnContainer"}>
                <div className={"flexFill"}/>
                <input type="button" className="btn setupBtn"
                       value="Submit"
                       onClick={this.doStripe}/>
            </div>
        </div>;
    }
}

let currentReleaseStage = 'development';

if (process.env.VITE_IS_PRODUCTION  ==='true') currentReleaseStage = 'production';
else if (process.env.VITE_IS_TEST_MODE  ==='true') currentReleaseStage = 'test';
else if (!process.env.VITE_IS_DEVELOPMENT  ==='true') currentReleaseStage = 'staging';

const bugsnagClient = bugsnag(
    {
        apiKey: '45a754d74f2e667486a396a94a95cac5',
        notifyReleaseStages:
            ['production', 'staging'],
        releaseStage:
        currentReleaseStage
    });
bugsnagClient.use(bugsnagReact, React);
/**
 * Actual Authentication happens via Slack.
 * Once authenticated the user is available via devise.
 * The office.html.erb file contains a div with the currentUserId.
 * If that field has a valid value we can assume we have a user.
 */
export const SetupPageQube = ({
                                  setErrorMessage,
                                  errorMessage,
                                  suggestedEmail,
                                  suggestedToken,
                                  subdomain,
                                  zoomError,
                                  slackUnhappy,
                                  hasUserName,
                                  setHasUserName,
                                  slackError,
                                  currentCircleIndex,
                                  setCurrentCircleIndexInState,
                                  completedIdxs,
                                  setCompletedIdx,
                                  steps,
                                  username,
                                  setUsername,
                                  setSubdomain,
                                  setSteps,
                                  setToken,
                                  token

                              }) => {
    const ErrorBoundary = bugsnagClient.getPlugin('react');


    useEffect(() => {
        setSteps([1, 2, 3, 4])
    }, [])
    const getItDone = () => {
        setCurrentCircleIndexInState(5);
        setCompletedIdx([1, 2, 3, 4]);
        doTrack('Workspace setup complete');
    };


    const setCurrentCircleIndex = (cIdx) => {
        if (username) {
            doTrack('Workspace setup - step ' + cIdx);
            setCurrentCircleIndexInState(cIdx);
        } else {
            doTrack('Workspace setup - no email, preventing progress');
            setErrorMessage('Please enter an email first and click "Submit".');
        }
    };

    const circleClass = (circleIdx) => {
        if (circleIdx === currentCircleIndex) {
            return classNames('setupCircle active');
        }
        if (_.indexOf(completedIdxs, circleIdx) < 0) {
            return classNames('setupCircle completed');
        }

        return classNames('setupCircle cursorPointer');
    };

    const circleText = (circleIdx) => {
        if (_.indexOf(completedIdxs, circleIdx) > -1) {
            return <span className={'fa fa-check'}/>;
        } else {
            return circleIdx;
        }
    };

    const handleSubdomain = (event) => {
        const target = event.target;
        const value = target.value;
        setSubdomain(value);
    };

    const handleUsername = (event) => {
        const target = event.target;
        const value = target.value;
        setUsername(value);
    };


    const submitRegistration = () => {
        setErrorMessage(null);
        createWorkspace(username)
            .then((response) => {
                mixpanel.people.set({
                    "$email": username
                });
                doTrack('Workspace setup - email submitted');
                setHasUserName(true);
                setToken(response.data.token);
                setCurrentCircleIndexInState(2);
                setCompletedIdx([1]);
            }).catch((error) => {
            if (error.data) {
                setErrorMessage(error.data.errors);
            } else {
                setErrorMessage(error.errors);
            }
        });
    };

    const renderErrorMessage = () => {
        let displayErrors = [];
        if (_.isString(errorMessage)) {
            displayErrors = [errorMessage];
        } else if (_.isArray(errorMessage)) {
            displayErrors = errorMessage;
        } else {
            displayErrors = _.map(_.keys(errorMessage), key => `${key} ${errorMessage[key]}`);
        }
        return !_.isEmpty(displayErrors) ? (<div className={"flexRowContainer flexAlignCenter mt15"}>
            {_.map(displayErrors, error => <div className={"flexColumnContainer text-danger"}>
                <span className={"fa fa-warning pr5"}/>
                <span className={'upperCaseFirstLetter'}><strong>{error}</strong></span>
            </div>)}
        </div>) : null;
    };


    const submitWithoutStripe = (officeSize, subdomain) => {
        finalizeWorkspace({
            email: username,
            subdomain: subdomain,
            size: officeSize,
            workspaceToken: token
        }).then(() => {
            generateWorkspace({
                email: username,
                token: token
            }).then(() => getItDone())
                .catch(error => {
                    if (error.data) {
                        setErrorMessage(error.data.errors);
                    } else {
                        setErrorMessage(error.errors);
                    }
                });
        }).catch(error => {
            if (error.data) {
                setErrorMessage(error.data.errors);
            } else {
                setErrorMessage(error.errors);
            }
        })
    };

    const proceedToRegistration = () => {
      setCurrentCircleIndexInState(1);
    };
    const base64TokenAndEmail = btoa(token + '|' + username);
    useEffect(() => doTrack('Starting workspace setup'), []);

    const currentDomain = window.location.host;
    const redirectUrl = _.replace(window.location.origin, 'lvh.me', 'localhost');
    return (
        <ErrorBoundary>
            <div className={"setupContainer flexRowContainer flexAlignCenter positionRelative"}>
                {currentCircleIndex === 0 && <PreflightCheck proceedToRegistration={proceedToRegistration}/>}

                {currentCircleIndex !== 5 && currentCircleIndex !== 0 &&
                <div className={"flexColumnContainer mb20 mt20"}>
                    {
                        _.map(steps, step => {
                            return <div className={"flexColumnContainer"}>
                                <div className={circleClass(step)}
                                     onClick={() => setCurrentCircleIndex(step)}>{circleText(step)}</div>
                                {!_.isEqual(step, _.last(steps)) && <div className={"setupSeperator"}/>}
                            </div>
                        })
                    }
                </div>
                }

                {currentCircleIndex === 1 && <Email hasUserName={hasUserName}
                                                    handleUsername={handleUsername}
                                                    submitRegistration={submitRegistration}
                                                    renderErrorMessage={renderErrorMessage}
                                                    username={username}/>}

                {currentCircleIndex === 2 && <ConnectToSlack
                    slackUnhappy={slackUnhappy}
                    renderErrorMessage={renderErrorMessage}
                    completedIdxs={completedIdxs}
                    slackError={slackError}
                    suggestedEmail={suggestedEmail}
                    suggestedToken={suggestedToken}
                    redirectUrl={redirectUrl}
                    base64TokenAndEmail={base64TokenAndEmail}/>
                }

                {currentCircleIndex === 3 &&
                <ConnectToZoom completedIdxs={completedIdxs}
                               currentDomain={currentDomain}
                               token={token}
                               username={username}
                               redirectUrl={redirectUrl}
                               suggestedEmail={suggestedEmail}
                               suggestedToken={suggestedToken}
                               zoomError={zoomError}
                               renderErrorMessage={renderErrorMessage}/>
                }

                {currentCircleIndex === 4 && <OfficeConfiguration
                    submitWithoutStripe={submitWithoutStripe}
                    renderErrorMessage={renderErrorMessage}
                    currentDomain={currentDomain}
                    subdomain={subdomain}
                    handleSubdomain={handleSubdomain}/>
                }

                {currentCircleIndex === 5 && <FinalStep currentDomain={currentDomain} subdomain={subdomain}/>}

                <div className={'setupHelp'}>Need help? <a href={'mailto:qube@seeq.com'}>Contact us</a>
                </div>

            </div>
        </ErrorBoundary>
    );
};

export default SetupPageQube;
